import { SessionConfigFlags, SoundProcessorOptions } from '@yandex-video-platform/goloom-sdk';

import { TelemostBackendErrorCode } from './types';

export const KICKED_WHILE_RECONNECTING = 'KICKED_WHILE_RECONNECTING';

export const DEFAULT_FLAGS: SessionConfigFlags = {
    reportTelemetry: true,
};

export const SOUND_PROCESSING_OPTIONS: SoundProcessorOptions = {
    noiseCancellation: true,
    localVad: true,
    rms: true,
    dtmf: false,
};

export const DISABLED_SOUND_PROCESSING_OPTIONS: SoundProcessorOptions = {
    noiseCancellation: false,
    localVad: false,
    rms: false,
    dtmf: false,
};

export const DEFAULT_MEDIA_SERVER_URL = 'wss://goloom.strm.yandex.net/join';
export const DEFAULT_SERVICE_NAME = 'telemost';
export const DEFAULT_ICE_SERVERS = [{ urls: 'stun:stun.rtc.yandex.net:3478' }];

export const CLOSE_ERROR_CODES_TO_RETRY = [1006, 1011];
export const BACKEND_ERROR_CODES_TO_RETRY = [
    TelemostBackendErrorCode.CREDENTIALS_EXPIRED,
    TelemostBackendErrorCode.SESSION_NOT_FOUND,
    TelemostBackendErrorCode.INCORRECT_CREDENTIALS,
] as const;
